// Components
import Asteric from './Asteric';

import ReactTooltip from 'react-tooltip';
import { classNames } from 'primereact/utils';

const Label = (props) => {
  const {
    htmlFor,
    className,
    text,
    labelText,
    isMandatory,
    isChildren,
    isBold,
    tooltip,
    ishidden,
    onFocus,
    onBlur
  } = props;
  const content = text || labelText;
  return (
    <label
      htmlFor={htmlFor}
      className={[
        !isBold ? 'text-gray font-bold' : '',
        ishidden ? 'hide-label' : '',
        className || ''
      ].join(' ')}>
      <span
        className={classNames({
          'input-focus': onFocus,
          'text-gray': onBlur
        })}>
        {content}
      </span>
      {isMandatory && <Asteric />}
      {isChildren && (
        <>
          <ReactTooltip />
          <i
            className="custom-target-icon pi pi-info-circle pl-1"
            data-tip={tooltip}
            style={{ cursor: 'pointer' }}
          />
        </>
      )}
    </label>
  );
};

export default Label;
